/*==================================================================  
MEGA MENU
==================================================================*/

const megaMenuLinks = document.querySelectorAll('.has-mega-menu');
const megaMenuFull = document.querySelectorAll('.mega-menu-full');
const megaMenuHoverLinks = document.querySelectorAll('.has-hover-images');

megaMenuLinks.forEach(link => {
  link.addEventListener('mouseover', e => {
    const target = e.currentTarget;
    const megaMenu = target.nextElementSibling;
    megaMenu.setAttribute('open', true);
    target.classList.add('mega-menu-open');
    document.querySelector('.header__heading-link').classList.add('mega-menu-open');
    document.querySelector('.header__icons').classList.add('mega-menu-open');
  });
});

megaMenuFull.forEach(menu => {
  menu.addEventListener('mouseleave', e => {
    const target = e.currentTarget;
    const link = target.previousElementSibling;
    target.removeAttribute('open');
    link.classList.remove('mega-menu-open');
    document.querySelector('.header__heading-link').classList.remove('mega-menu-open');
    document.querySelector('.header__icons').classList.remove('mega-menu-open');
  });
});

megaMenuHoverLinks.forEach(link => {
  link.addEventListener('mouseover', e => {
    const target = e.currentTarget;
    const colHandle = target.dataset.collectionHandle;
    const parent = target.closest('.mega-menu-full');
    const hoverImages = parent.querySelector('.menu-hover-images');
    const prodHoverImg = hoverImages.querySelector(`[data-collection="${colHandle}"]`);

    parent.querySelectorAll('[data-collection]').forEach(col => col.setAttribute('hidden', true));
    prodHoverImg.removeAttribute('hidden');
    // const products = JSON.parse(document.getElementById(`Collection-${colHandle}-json`).textContent);

    // hoverImages.innerHTML = prodHoverImg;
    // if (products.length > 0) {
    //   for (let i = 0; i < 3; i++) {
    //     if (!products[i]) continue;
    //     const hoverDiv = document.createElement('div');
    //     const img = document.createElement('img');
    //     hoverDiv.className = 'hover-image-wrapper';
    //     img.src = products[i].featured_image || products[i].media[0].src;
    //     img.alt = products[i].media[0].alt;
    //     hoverDiv.appendChild(img);
    //     // hoverImages.innerHTML += `
    //     //   <div class="hover-image-wrapper">
    //     //     <img src="${products[i].featured_image || products[i].media[0].src}" alt="${products[i].media[0].alt}" />
    //     //   </div>
    //     // `;
    //     hoverImages.appendChild(hoverDiv);
    //   }
    // }
  });
});

/*==================================================================  
PRODUCT PAGE
==================================================================*/

const atcButton = document.querySelector('button.product-form__submit');
const mobileAtc = document.getElementById('mobile-add-to-cart');

if (mobileAtc) {
  mobileAtc.addEventListener('click', e => {
    atcButton.click();
  });
}

document.addEventListener('scroll', () => {
  // Get the element
  const targetElement = document.querySelector('.product-main-section');

  if (targetElement) {
      // Get the element's position and height
      const rect = targetElement.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      // Check if the top of the element is in view
      if (rect.top >= 0 && rect.top <= windowHeight) {
        targetElement.setAttribute('data-position', 'top');
      }

      // Check if the scroll is in the middle of the element
      if (rect.top < windowHeight && rect.bottom > windowHeight) {
        targetElement.setAttribute('data-position', 'middle');
      }

      // Check if the bottom of the element is in view
      if (rect.bottom <= windowHeight) {
        targetElement.setAttribute('data-position', 'bottom');
      }
  }
});